import { Link } from "@tanstack/react-router";
import clsx from "clsx";
import { FiPlus } from "react-icons/fi";
import { SearchBar } from "@/features/catalog/components";
import {
  type SortType,
  useCatalogStore,
} from "@/features/catalog/stores/catalogStore";
import { useThreadCreateModalStore } from "@/features/thread/stores/threadCreateModalStore";
import { ViewModeToggle } from "./ViewModeToggle";

const SORT_OPTIONS: { key: SortType; label: string }[] = [
  { key: "default", label: "カタ" },
  { key: "created", label: "新順" },
  { key: "old", label: "古順" },
  { key: "replies", label: "多順" },
  { key: "momentum", label: "勢順" },
  { key: "soudane", label: "そ順" },
];

/**
 * Catalog page の Desktop 用 toolbar (PC のみ表示)。
 * `useDesktopChrome` 経由で `DesktopHeader` の toolbar slot に流し込まれる。
 *
 * 構成（既存機能のみ、新規機能は載せない）:
 *   ViewModeToggle / SortNav / 設定 / + 新規スレ / 検索
 */
export const CatalogToolbar: React.FunctionComponent = () => {
  const { currentSort, setSort } = useCatalogStore();
  const openThreadCreate = useThreadCreateModalStore((s) => s.open);

  return (
    <>
      <ViewModeToggle />

      <div className="flex items-center gap-1 ml-2">
        {SORT_OPTIONS.map(({ key, label }) => (
          <button
            type="button"
            key={key}
            className={clsx(
              "px-2 py-1 text-sm rounded transition-colors",
              currentSort === key
                ? "bg-primary text-primary-foreground"
                : "text-foreground hover:bg-muted",
            )}
            onClick={(): void => setSort(key)}
          >
            {label}
          </button>
        ))}
      </div>

      <Link
        to="/settings"
        className="px-3 py-1.5 text-sm text-foreground hover:bg-muted rounded transition-colors"
      >
        設定
      </Link>

      <button
        type="button"
        onClick={openThreadCreate}
        className="ml-auto flex items-center gap-1 px-3 py-1.5 text-sm bg-accent text-accent-foreground rounded hover:bg-accent/90 transition-colors"
      >
        <FiPlus size={16} />
        新規スレ
      </button>

      <div className="w-64">
        <SearchBar />
      </div>
    </>
  );
};
